import { useEffect, useState } from 'react';
import MaintenanceLogReportFilter from './MaintenanceLogReportFilter/MaintenanceLogReportFilter';
import MaintenanceLogReportDataTable from './MaintenanceLogReportDataTable/MaintenanceLogReportDataTable';

function MaintenanceLogReport() {
  const [vehicle, setVehicle] = useState({
    vehicleId: 0,
    description: '- Todos -'
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [refresh, setRefresh] = useState(0);  

  // #region Events

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  
  const onVehicleChange = (vehicle) => {
    setVehicle(vehicle);    
  };

  const onStartDateChange = (date) => {
    setStartDate(date);
  };

  const onEndDateChange = (date) => {
    setEndDate(date);
  };

  const onSearchPress = (date) => {
    setRefresh(refresh + 1);
  };
  
  // #endregion

  // #region Templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Bitácora de Mantenimientos
          </h1>
        </section>
        <section className='pb-2'>
          <MaintenanceLogReportFilter 
            vehicle={vehicle}
            startDate={startDate}
            endDate={endDate}
            onVehicleChange={onVehicleChange}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            onSearchPress={onSearchPress}
          />
        </section>
        <section>
          <MaintenanceLogReportDataTable
            vehicle={vehicle}
            startDate={startDate}
            endDate={endDate}
            refresh={refresh}
          />
        </section>
      </article>
    </>
  );

  // #endregion

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default MaintenanceLogReport;